import * as React from "react";
import styles from "./prospectGraph.module.css";
import PieProspectChart from "./PieProspectChart";
import { styled } from "@mui/material/styles";
import { Tooltip } from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";

const ListDonutWidget = ({ donutGraphData, no_of_prospect }) => {
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      fontSize: 13,
    },
  }));

  const transformedDonutData = {
    categories: [
      {
        title: "Calls",
        total:
          (donutGraphData?.call_received || 0) +
          (donutGraphData?.call_sent || 0),
        completed: donutGraphData?.call_received || 0,
        pending: donutGraphData?.call_sent || 0,
        color: "#00BFFF", // Green
        color1: "#0e8db9",
      },
      {
        title: "Messages",
        total:
          (donutGraphData?.message_received || 0) +
          (donutGraphData?.message_sent || 0),
        completed: donutGraphData?.message_received || 0,
        pending: donutGraphData?.message_sent || 0,
        color: "#32CD32", // Blue
        color1: "#299a29",
      },
      {
        title: "Tours",
        total:
          (donutGraphData?.tour_completed || 0) +
          (donutGraphData?.tour_scheduled || 0),
        completed: donutGraphData?.tour_completed || 0,
        pending: donutGraphData?.tour_scheduled || 0,
        color: "#BA55D3", // Orange
        color1: "#863d98",
      },
    ],
  };

  return (
    <>
      <div className={`${styles.ChartMainSec}`}>
        <div className={`${styles.TotalIncomeSec}`}>
          <p className={`${styles.Text}`}>Totals</p>
          <p className={`${styles.Text2}`}>
            Prospects: {no_of_prospect}
          </p>
          <p className={`${styles.Text2}`}>
            Calls:{" "}
            {(donutGraphData?.call_received || 0) +
              (donutGraphData?.call_sent || 0)}
          </p>
          <p className={`${styles.Text2}`}>
            Messages:{" "}
            {(donutGraphData?.message_received || 0) +
              (donutGraphData?.message_sent || 0)}
          </p>
          <p className={`${styles.Text2}`}>
            Tours:{" "}
            {(donutGraphData?.tour_completed || 0) +
              (donutGraphData?.tour_scheduled || 0)}
          </p>
        </div>
        <div className={`${styles.ChartSec}`}>
          <PieProspectChart categories={transformedDonutData.categories} />
        </div>
      </div>

      <div className={`${styles.ChartListCatMain}`}>
        {transformedDonutData.categories.map((c, i) => {
          const total = c.total || 0;
          const completed = c.completed || 0;
          const pending = c.pending || 0;
          const completedPercent = total ? (completed / total) * 100 : 0;
          const pendingPercent = total ? (pending / total) * 100 : 0;

          return (
            <div className={styles.ChartListCat} key={i}>
              <p>
                {c.title} <span>{total.toLocaleString()}</span>
              </p>
              <div className={styles.ChartProgressTrack}>
                <BootstrapTooltip
                  title={
                    <div className={styles.IncomeLineTooltip}>
                      <p>
                        {c.title === "Tours" ? "Completed" : "Inbound"}:{" "}
                        {completed.toLocaleString()}
                      </p>
                    </div>
                  }
                >
                  <div
                    style={{
                      width: `${completedPercent}%`,
                      backgroundColor: c.color,
                      cursor: "pointer",
                    }}
                  ></div>
                </BootstrapTooltip>

                <BootstrapTooltip
                  title={
                    <div className={styles.IncomeLineTooltip}>
                      <p>
                        {c.title === "Tours" ? "Scheduled" : "Outbound"}:{" "}
                        {pending.toLocaleString()}
                      </p>
                    </div>
                  }
                >
                  <div
                    style={{
                      width: `${pendingPercent}%`,
                      backgroundColor: c.color,
                      cursor: "pointer",
                      filter: 'brightness(0.75)'
                    }}
                  ></div>
                </BootstrapTooltip>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ListDonutWidget;
